import { owesReplyAgainstDeadline } from "./sla-window"

type DateLike = Date | number | string | null | undefined

/** How long after coming back the inbox still offers the cover's threads back. */
export const OUT_OF_OFFICE_RETURN_WINDOW_MS = 7 * 24 * 60 * 60 * 1000

function toMs(value: DateLike): number | null {
	if (value === null || value === undefined) return null
	const ms = typeof value === "number" ? value : new Date(value).getTime()
	return Number.isNaN(ms) ? null : ms
}

export function isOutOfOffice(until: DateLike, now = Date.now()): boolean {
	const ms = toMs(until)
	return ms !== null && ms > now
}

export function isRecentlyBack(until: DateLike, now = Date.now()): boolean {
	const ms = toMs(until)
	return ms !== null && ms <= now && now - ms < OUT_OF_OFFICE_RETURN_WINDOW_MS
}

export interface ReplyStateThread {
	replied?: boolean | null
	slaDeadlineAt?: DateLike
	lastInboundMessageAt?: DateLike
	lastOutboundMessageAt?: DateLike
}

/** The customer wrote last, or an SLA is still counting against us. */
export function isWaitingOnUs(thread: ReplyStateThread): boolean {
	const inbound = toMs(thread.lastInboundMessageAt)
	const outbound = toMs(thread.lastOutboundMessageAt)
	if (inbound !== null && (outbound === null || inbound > outbound)) return true

	const deadline = toMs(thread.slaDeadlineAt)
	if (!deadline) return false
	return owesReplyAgainstDeadline({
		replied: thread.replied,
		slaDeadlineAt: deadline,
		lastInboundMessageAt: inbound,
		lastOutboundMessageAt: outbound,
	})
}
